<div [formGroup]="subscriptionSecretForm" class="form flex flex-col">
  <nx-edit-text-input
    [maskContent]="true"
    formControlName="secret"
    label="coreModuleModule.subscriptionSecretDialogComponent.form.secret.label">
  </nx-edit-text-input>
<div>